import { resolveVuetifyTheme } from '@core/utils/vuetify'
import { themeConfig } from '@themeConfig'

export const staticPrimaryColor = '#003366' //nayak blue

const theme = {
  defaultTheme: resolveVuetifyTheme(),
  themes: {
    light: {
      dark: false,
      colors: {
        'primary': '#003366',
        'on-primary': '#fff',
        'secondary': '#6D788D',
        'on-secondary': '#fff',
        'success': '#72E128',
        'on-success': '#fff',
        'info': '#26C6F9',
        'on-info': '#fff',
        'warning': '#FDB528',
        'on-warning': '#fff',
        'error': '#FF4D49',
        'background': '#F7F7F9',
        'on-background': '#4c4e64',
        'on-surface': '#4c4e64',
        'snackbar-background': '#212121',
        'tooltip-background': '#262732',
        'alert-background': '#F7F7F9',
        'grey-50': '#FAFAFA',
        'grey-100': '#F4F5FA',
        'grey-200': '#F5F5F7',
        'grey-300': '#E0E0E0',
        'grey-400': '#BDBDBD',
        'grey-500': '#9E9E9E',
        'grey-600': '#757575',
        'grey-700': '#616161',
        'grey-800': '#424242',
        'grey-900': '#212121',
        'perfect-scrollbar-thumb': '#DBDADE',
        'skin-bordered-background': '#fff',
        'skin-bordered-surface': '#fff',
        'NayakSilver': '#CCCCCC',
        'NayakBlue': '#003366',
        'NayakOrange': '#CC6600',
        'NayakBlack':  '#000000'
      },
      variables: {
        'code-color': '#d400ff',
        'border-color': '#4c4e64',
        'hover-opacity': 0.05,
        'overlay-scrim-background': '#4C4E64',
        'overlay-scrim-opacity': 0.5,
        'focus-opacity': 0.1,
        'selected-opacity': 0.12,
        'activated-opacity': 0.1,
        'pressed-opacity': 0.14,
        'dragged-opacity': 0.1,
        'table-header-background': '#F5F5F7',

        // Shadows
        'shadow-key-umbra-opacity': 0.2,
        'shadow-key-penumbra-opacity': 0.14,
        'shadow-key-ambient-opacity': 0.12,
        'shadow-key-umbra-color': '#4C4E64',
        'shadow-key-penumbra-color': '#4C4E64',
        'shadow-key-ambient-color': '#4C4E64',
      },
    },
    dark: {
      dark: true,
      colors: {
        'primary':  '#0157a6',
        'on-primary': '#fff',
        'secondary': '#6D788D',
        'on-secondary': '#fff',
        'success': '#72E128',
        'on-success': '#fff',
        'info': '#26C6F9',
        'on-info': '#fff',
        'warning': '#FDB528',
        'on-warning': '#fff',
        'error': '#FF4D49',
        'background': '#16161c',
        'on-background': '#eaeaff',
        'surface': '#181927',
        'on-surface': '#eaeaff',
        'snackbar-background': '#F5F5F5',
        'on-snackbar-background': '#30334E',
        'tooltip-background': '#464A65',
        'alert-background': '#282A42',
        'grey-50': '#2A2E42',
        'grey-100': '#41435c',
        'grey-200': '#3A3E5B',
        'grey-300': '#5E6692',
        'grey-400': '#7983BB',
        'grey-500': '#8692D0',
        'grey-600': '#AAB3DE',
        'grey-700': '#B6BEE3',
        'grey-800': '#CFD3EC',
        'grey-900': '#E7E9F6',
        'perfect-scrollbar-thumb': '#4A5072',
        'skin-bordered-background': '#282A42',
        'skin-bordered-surface': '#282A42',
        'NayakSilver': '#CCCCCC',
        'NayakBlue': '#003366',
        'NayakOrange': '#CC6600',
        'NayakBlack':  '#000000'

      },
      variables: {
        'code-color': '#d400ff',
        'border-color': '#eaeaff',
        'hover-opacity': 0.05,
        'overlay-scrim-background': '#101121',
        'overlay-scrim-opacity': 0.6,
        'focus-opacity': 0.1,
        'selected-opacity': 0.12,
        'activated-opacity': 0.1,
        'pressed-opacity': 0.14,
        'dragged-opacity': 0.1,
        'table-header-background': '#3A3E5B',

        // Shadows
        'shadow-key-umbra-opacity': 0.2,
        'shadow-key-penumbra-opacity': 0.14,
        'shadow-key-ambient-opacity': 0.12,
        'shadow-key-umbra-color': '#30334E',
        'shadow-key-penumbra-color': '#30334E',
        'shadow-key-ambient-color': '#30334E',
      },
    },

    // Warm Charcoal — VS Code Dark+ inspired (default dark style)
    'dark-charcoal': {
      dark: true,
      colors: {
        'primary': '#569cd6',
        'on-primary': '#fff',
        'secondary': '#858585',
        'on-secondary': '#fff',
        'success': '#4ec994',
        'on-success': '#fff',
        'info': '#9cdcfe',
        'on-info': '#1e1e1e',
        'warning': '#ce9178',
        'on-warning': '#1e1e1e',
        'error': '#f44747',
        'background': '#1e1e1e',
        'on-background': '#d4d4d4',
        'surface': '#252526',
        'on-surface': '#d4d4d4',
        'snackbar-background': '#f5f5f5',
        'on-snackbar-background': '#1e1e1e',
        'tooltip-background': '#3c3c3c',
        'alert-background': '#2d2d30',
        'grey-50': '#2d2d30',
        'grey-100': '#3c3c3c',
        'grey-200': '#3e3e42',
        'grey-300': '#505050',
        'grey-400': '#6a6a6a',
        'grey-500': '#858585',
        'grey-600': '#a0a0a0',
        'grey-700': '#b8b8b8',
        'grey-800': '#cccccc',
        'grey-900': '#d4d4d4',
        'perfect-scrollbar-thumb': '#505050',
        'skin-bordered-background': '#2d2d30',
        'skin-bordered-surface': '#2d2d30',
        'NayakSilver': '#CCCCCC',
        'NayakBlue': '#003366',
        'NayakOrange': '#CC6600',
        'NayakBlack': '#000000',
      },
      variables: {
        'code-color': '#d400ff',
        'border-color': '#d4d4d4',
        'hover-opacity': 0.05,
        'overlay-scrim-background': '#000000',
        'overlay-scrim-opacity': 0.6,
        'focus-opacity': 0.1,
        'selected-opacity': 0.12,
        'activated-opacity': 0.1,
        'pressed-opacity': 0.14,
        'dragged-opacity': 0.1,
        'table-header-background': '#2d2d30',

        // Shadows
        'shadow-key-umbra-opacity': 0.2,
        'shadow-key-penumbra-opacity': 0.14,
        'shadow-key-ambient-opacity': 0.12,
        'shadow-key-umbra-color': '#141414',
        'shadow-key-penumbra-color': '#141414',
        'shadow-key-ambient-color': '#141414',
      },
    },

    // Steel Neutral — GitHub Dark + VS Code Modern inspired
    'dark-steel': {
      dark: true,
      colors: {
        'primary': '#4493f8',
        'on-primary': '#fff',
        'secondary': '#768390',
        'on-secondary': '#fff',
        'success': '#3fb950',
        'on-success': '#fff',
        'info': '#39c5cf',
        'on-info': '#fff',
        'warning': '#d29922',
        'on-warning': '#fff',
        'error': '#f85149',
        'background': '#0d1117',
        'on-background': '#e6edf3',
        'surface': '#161b22',
        'on-surface': '#e6edf3',
        'snackbar-background': '#f0f6fc',
        'on-snackbar-background': '#1c2128',
        'tooltip-background': '#2d333b',
        'alert-background': '#21262d',
        'grey-50': '#1c2128',
        'grey-100': '#2d333b',
        'grey-200': '#373e47',
        'grey-300': '#444c56',
        'grey-400': '#545d68',
        'grey-500': '#768390',
        'grey-600': '#909dab',
        'grey-700': '#adbac7',
        'grey-800': '#cdd9e5',
        'grey-900': '#e6edf3',
        'perfect-scrollbar-thumb': '#444c56',
        'skin-bordered-background': '#21262d',
        'skin-bordered-surface': '#21262d',
        'NayakSilver': '#CCCCCC',
        'NayakBlue': '#003366',
        'NayakOrange': '#CC6600',
        'NayakBlack': '#000000',
      },
      variables: {
        'code-color': '#d400ff',
        'border-color': '#adbac7',
        'hover-opacity': 0.05,
        'overlay-scrim-background': '#0d1117',
        'overlay-scrim-opacity': 0.6,
        'focus-opacity': 0.1,
        'selected-opacity': 0.12,
        'activated-opacity': 0.1,
        'pressed-opacity': 0.14,
        'dragged-opacity': 0.1,
        'table-header-background': '#21262d',

        // Shadows
        'shadow-key-umbra-opacity': 0.2,
        'shadow-key-penumbra-opacity': 0.14,
        'shadow-key-ambient-opacity': 0.12,
        'shadow-key-umbra-color': '#090d12',
        'shadow-key-penumbra-color': '#090d12',
        'shadow-key-ambient-color': '#090d12',
      },
    },

    // Midnight Blue — Linear + Tailwind Slate inspired
    'dark-midnight': {
      dark: true,
      colors: {
        'primary': '#3b82f6',
        'on-primary': '#fff',
        'secondary': '#64748b',
        'on-secondary': '#fff',
        'success': '#22c55e',
        'on-success': '#fff',
        'info': '#38bdf8',
        'on-info': '#0f172a',
        'warning': '#f59e0b',
        'on-warning': '#0f172a',
        'error': '#ef4444',
        'background': '#0f172a',
        'on-background': '#f1f5f9',
        'surface': '#1e293b',
        'on-surface': '#f1f5f9',
        'snackbar-background': '#f8fafc',
        'on-snackbar-background': '#0f172a',
        'tooltip-background': '#334155',
        'alert-background': '#1e293b',
        'grey-50': '#1e293b',
        'grey-100': '#293548',
        'grey-200': '#334155',
        'grey-300': '#475569',
        'grey-400': '#64748b',
        'grey-500': '#94a3b8',
        'grey-600': '#94a3b8',
        'grey-700': '#cbd5e1',
        'grey-800': '#e2e8f0',
        'grey-900': '#f1f5f9',
        'perfect-scrollbar-thumb': '#475569',
        'skin-bordered-background': '#1e293b',
        'skin-bordered-surface': '#1e293b',
        'NayakSilver': '#CCCCCC',
        'NayakBlue': '#003366',
        'NayakOrange': '#CC6600',
        'NayakBlack': '#000000',
      },
      variables: {
        'code-color': '#d400ff',
        'border-color': '#cbd5e1',
        'hover-opacity': 0.05,
        'overlay-scrim-background': '#0f172a',
        'overlay-scrim-opacity': 0.6,
        'focus-opacity': 0.1,
        'selected-opacity': 0.12,
        'activated-opacity': 0.1,
        'pressed-opacity': 0.14,
        'dragged-opacity': 0.1,
        'table-header-background': '#1e293b',

        // Shadows
        'shadow-key-umbra-opacity': 0.2,
        'shadow-key-penumbra-opacity': 0.14,
        'shadow-key-ambient-opacity': 0.12,
        'shadow-key-umbra-color': '#0c1322',
        'shadow-key-penumbra-color': '#0c1322',
        'shadow-key-ambient-color': '#0c1322',
      },
    },
  },
}

export default theme
